import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/gaurds/auth/auth.guard';


const routes: Routes = [
  {
    path: '', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/account/account.module').then(mode => mode.AccountModule),
  },
  {
    path: 'dashboard', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(mode => mode.DashboardModule),
  },
  {
    path: 'support', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/support/support.module').then(mode => mode.SupportModule),
  },
  {
    path: 'sales', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/sales/sales.module').then(mode => mode.SalesModule),
  },
  {
    path: 'marketing', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/marketing/marketing.module').then(mode => mode.MarketingModule),
  },
  {
    path: 'operations', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/operations/operations.module').then(mode => mode.OperationsModule),
  },
  {
    path: 'it', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/it/it.module').then(mode => mode.ItModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
